var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { mergeDeepRight, omit } from 'ramda';
export var CallStatus;
(function (CallStatus) {
    CallStatus["REGISTERED"] = "registered";
    CallStatus["ONGOING"] = "ongoing";
    CallStatus["ENDED"] = "ended";
    CallStatus["ERROR"] = "error";
})(CallStatus || (CallStatus = {}));
export var CallRecommendation;
(function (CallRecommendation) {
    CallRecommendation["RECOMMEND_CALL"] = "recommend_call";
    CallRecommendation["DONT_RECOMMEND_CALL"] = "do_not_call";
    CallRecommendation["VALIDATED"] = "validated";
})(CallRecommendation || (CallRecommendation = {}));
export var Availability;
(function (Availability) {
    Availability["YES"] = "yes";
    Availability["NO"] = "no";
    Availability["UNKNOWN"] = "unknown";
})(Availability || (Availability = {}));
export var useCarePlanDraftStore = create(persist(function (set) { return ({
    activeAiCalls: [],
    addActiveAiCall: function (call) {
        return set(function (state) { return ({
            activeAiCalls: __spreadArray(__spreadArray([], state.activeAiCalls, true), [call], false)
        }); });
    },
    removeActiveAiCall: function (callId) {
        return set(function (state) { return ({
            activeAiCalls: state.activeAiCalls.filter(function (call) { return call.callId !== callId; })
        }); });
    },
    drafts: {},
    activeDraftId: null,
    setActiveDraft: function (id) { return set({ activeDraftId: id }); },
    resetActiveDraft: function () { return set({ activeDraftId: null }); },
    updateDraft: function (draftId, entityId, data) {
        return set(function (state) {
            var _a, _b;
            var _c;
            return ({
                drafts: __assign(__assign({}, state.drafts), (_a = {}, _a[draftId] = __assign(__assign({}, state.drafts[draftId]), (_b = {}, _b[entityId] = mergeDeepRight((_c = state.drafts[draftId]) === null || _c === void 0 ? void 0 : _c[entityId], data), _b)), _a))
            });
        });
    },
    removeDraftEntity: function (draftId, entityId) {
        return set(function (state) {
            var _a;
            return ({
                drafts: __assign(__assign({}, state.drafts), (_a = {}, _a[draftId] = omit([entityId], state.drafts[draftId]), _a))
            });
        });
    },
}); }, {
    name: 'carePlanDraft'
}));
export var selectActiveAiCalls = function (state) { return ({
    activeAiCalls: state.activeAiCalls,
    addActiveAiCall: state.addActiveAiCall,
    removeActiveAiCall: state.removeActiveAiCall
}); };
export var selectDrafts = function (state) { return ({ drafts: state.drafts, updateDraft: state.updateDraft }); };
